module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec_bg_10-1b5bf7cbeb6f2ce9ba2613014b8de22e.svg";